import { observer } from 'mobx-react-lite';
import {
  Card,
  CardContent,
  Typography,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import { useThemeStore } from '../../stores/root_store';
import type { ThemePreference } from '../../stores/theme_store';

export const SettingsAppearance = observer(() => {
  const themeStore = useThemeStore();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    themeStore.setPreference(event.target.value as ThemePreference);
  };

  return (
    <Card>
      <CardContent>
        <FormControl component="fieldset">
          <FormLabel component="legend">
            <Typography variant="h6" gutterBottom>
              Theme
            </Typography>
          </FormLabel>
          <RadioGroup
            value={themeStore.preference}
            onChange={handleChange}
          >
            <FormControlLabel
              value="light"
              control={<Radio />}
              label="Light"
            />
            <FormControlLabel
              value="dark"
              control={<Radio />}
              label="Dark"
            />
            <FormControlLabel
              value="system"
              control={<Radio />}
              label="System (follow device settings)"
            />
          </RadioGroup>
        </FormControl>
      </CardContent>
    </Card>
  );
});
